import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-20577bfa"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "time-slider"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-DEM" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-D" }, null, -1))

import { computed, watch } from 'vue';
import * as Cesium from 'cesium';
import { useStore } from 'vuex';

const min = 240;
const max = 250;

export default /*#__PURE__*/_defineComponent({
  __name: 'TimeSlider',
  props: {
  viewer: {
    type: Cesium.Viewer,
  }
},
  setup(__props) {

const props = __props;



const store = useStore();
const state = store.state;
const visibleValue = computed(() => store.state.timelineStore.visible);
const isPlayingValue = computed(() => store.state.timelineStore.isPlaying);
const demValue = computed(() => store.state.timelineStore.dem);
const button3DType = computed(() => props.viewer.scene.mode === Cesium.SceneMode.SCENE3D ? 'primary' : 'default');
let intervalId = null;

const selectedSpeed = computed(() => state.timelineStore.currentSpeed + '')

const speeds = [
  { label: 'x1', value: '2000' },
  { label: 'x2', value: '1000' },
  { label: 'x4', value: '500' },
  { label: 'x8', value: '250' },
  { label: 'x10', value: '200' },
  { label: 'x16', value: '125' },
];

const updateSpeed = (speed) => {
  store.commit('timelineStore/setCurrentSpeed', speed);
  if (state.timelineStore.isPlaying) {
    startPlay();
  }
}

// const updateLayer = () => {
//   let viewer = props.viewer;
//   fetch(`https://deep-time.org/v1.0/api/data-central/dataset/atom/timing?type=BaseMap&base=${state.timelineStore.currentTime}`).then(res => res.json()).then(res => {
//     if (res.code === 200) {
//       let { layerServiceInfo } = res.data;
//       if (layerServiceInfo.type === 'TMS') {
//         var layers = viewer.imageryLayers;
//         if(layers.length > 10){ 
//           layers.remove(layers.get(1));
//         }
//         let layer = {
//           url: layerServiceInfo.url,
//           maximumLevel: 3,
//           minimumLevel: 0,
//           tilingScheme: new Cesium.GeographicTilingScheme()
//         };
//         viewer?.imageryLayers.addImageryProvider(new Cesium.UrlTemplateImageryProvider(layer));
//       }
//     }
//   });
// }

const start = () => {
  store.commit('timelineStore/setCurrentTime', max);
};

const end = () => {
  store.commit('timelineStore/setCurrentTime', min);
};

const next = () => {
  if (state.timelineStore.currentTime > min) {
    const t = Math.max(state.timelineStore.currentTime - 1, min)
    store.commit('timelineStore/setCurrentTime', t);
  } else {
    stopPlay();
    store.commit('timelineStore/setIsPlaying', false);
  }
};

const toggleDEM = () => {
  store.commit('timelineStore/setDem', !state.timelineStore.dem);
  let viewer = props.viewer;
  if (state.timelineStore.dem) {
    viewer.scene.morphTo3D();
    viewer.scene.globe.terrainExaggeration = 100.0;
    viewer.scene.terrainProvider = new Cesium.CesiumTerrainProvider({
      url: store.state.timelineStore.demUrl + "/" + parseInt(state.timelineStore.currentTime),
      requestWaterMask: true,
      requestVertexNormals: true
    });
  } else {
    viewer.terrainProvider = new Cesium.EllipsoidTerrainProvider();
  }
}

const toggle3D = () => {
  if (props.viewer?.scene.mode === Cesium.SceneMode.SCENE3D) {
    props.viewer?.scene.morphTo2D();
  } else {
    props.viewer?.scene.morphTo3D();
  }
}

const prev = () => {
  if (state.timelineStore.currentTime < max) {
    const t = Math.min(state.timelineStore.currentTime + 1, max)
    store.commit('timelineStore/setCurrentTime', t);
  } else {
    stopPlay();
    store.commit('timelineStore/setIsPlaying', false);
  }
};

const startPlay = () => {
  if (intervalId) {
    clearInterval(intervalId);
  }
  intervalId = setInterval(next, selectedSpeed.value);
}

const stopPlay = () => {
  if (intervalId) {
    clearInterval(intervalId);
  }
}

const togglePlay = () => {
  if (state.timelineStore.isPlaying) {
    stopPlay();
  } else {
    startPlay();
  }
  store.commit('timelineStore/setIsPlaying', !state.timelineStore.isPlaying);
}

watch(visibleValue, (v) => {
  if (!v) {
    stopPlay();
    store.commit('timelineStore/setIsPlaying', false);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!

  return (visibleValue.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: selectedSpeed.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedSpeed).value = $event)),
              onChange: updateSpeed,
              style: {"width":"70px","margin-right":"10px"}
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(speeds, (speed) => {
                  return _createVNode(_component_el_option, {
                    key: speed.value,
                    label: speed.label,
                    value: speed.value
                  }, null, 8, ["label", "value"])
                }), 64))
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_el_button, {
              circle: "",
              icon: "DArrowLeft",
              onClick: start
            }),
            _createVNode(_component_el_button, {
              circle: "",
              icon: "ArrowLeft",
              onClick: prev
            }),
            (!isPlayingValue.value)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  circle: "",
                  icon: "VideoPlay",
                  onClick: togglePlay
                }))
              : _createCommentVNode("", true),
            (isPlayingValue.value)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 1,
                  circle: "",
                  type: "primary",
                  icon: "VideoPause",
                  onClick: togglePlay
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_button, {
              circle: "",
              icon: "ArrowRight",
              onClick: next
            }),
            _createVNode(_component_el_button, {
              circle: "",
              icon: "DArrowRight",
              onClick: end
            }),
            _createVNode(_component_el_button, {
              circle: "",
              type: demValue.value ? 'primary':'default',
              onClick: toggleDEM
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }, 8, ["type"]),
            _createVNode(_component_el_button, {
              circle: "",
              type: button3DType.value,
              onClick: toggle3D
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }, 8, ["type"])
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}
}

})